import React from 'react';
import moment from 'moment';

export const listDateFormatter = (cell, formatterParams, onRendered) => {
  const timezone = formatterParams['timezone'] ? formatterParams['timezone'] : "Asia/Taipei";
  const dateFormat = formatterParams['dateFormat'] ? formatterParams['dateFormat'] : "YYYY-MM-DD HH:mm:ss";
  return cell.getValue() ? moment.utc(cell.getValue().slice(0,19)).tz(timezone).format(dateFormat) : "";
}

export const booleanFormatter = (cell, formatterParams, onRendered) => {
  const trueFormat = formatterParams['trueFormat'] ? formatterParams['trueFormat'] : "enabled";
  const falseFormat = formatterParams['falseFormat'] ? formatterParams['falseFormat'] : "disabled";
  return cell.getValue() ? trueFormat : falseFormat;
}

export const doFilterList = (table, searchType, searchKeyword, allSelectValues, refFilter, refQuickFilters) => {
  let initFilters = refFilter || [];
  let quickFilters = refQuickFilters || [];
  if (table) {
    // do filter by different select filter type
    if (searchType) {
      table.setFilter([
        ...initFilters,
        quickFilters,
        {field: searchType, type:"like", value: searchKeyword }
      ]);
    } else {
      let allFilter = [];
      allSelectValues.forEach((selectValue) => {
        let filter = {field: selectValue, type:"like", value: searchKeyword};
        allFilter.push(filter);
      });
      table.setFilter([
        ...initFilters,
        quickFilters,
        // array is or condition
        allFilter        
      ]);      
    }
  }
}

export const toggleSelectType = (selectType, filterId) => {
  // set old chcik value to cancel checked
  let checkedEls = document.getElementsByClassName("icon-radiobutton-p");
  for (let i = 0; i < checkedEls.length; i++) {
    let checkedEl = checkedEls[i];
    checkedEl.className = 'icon-radiobutton-n';
  }    

  // set select value to checked
  let selectIdValue = selectType;
  if (!selectType) {
    selectIdValue = 'all';
  }

  let radioEl = document.getElementById(filterId + '-radio-select-type-' + selectIdValue);
  radioEl.className = "icon-radiobutton-p";
}

export const setPageNumber = (pageNumber) => {
    let btnGoPage = document.getElementById('go-page-button');
    btnGoPage.value = pageNumber;
}

export const getPageNumber = () => {
    let btnGoPage = document.getElementById('go-page-button');
    return btnGoPage.value;
}

export const updatePageNumber = (table) => {
  if (table) {
    let btnGoPage = document.getElementById('go-page-button');
    btnGoPage.value = table.getPage();
  }
}

export const updateMaxPageNumber = (table) => {
  if (table) {
    let pageMax = table.getPageMax();
    let maxPageEl = document.getElementById('page-max-label');
    maxPageEl.innerHTML = pageMax;
  }    
}

export const keepHeaderSort = (table) => {
  //keep Simple Sort from table sort
  let headerSort = {};

  // keep into simple sort
  let tableSort = table.getSorters();
  if (tableSort.length > 0) {
    // table only has one sort, so get first one
    let sort = tableSort[0];
    headerSort = {
      field: sort.field,
      dir: sort.dir
    };
  }

  return headerSort;
}

export const keepTableInfoToSession = (sessionKey, table, refFilterSearch) => {
  if (table) {
    const searchKeyword = refFilterSearch.state.searchKeyword;
    const searchType = refFilterSearch.state.searchType;
    const headerSort = keepHeaderSort(table);

    const tableInfo = {
      page : table.getPage(),
      filters : table.getFilters(),
      headerSort : headerSort,
      searchKeyword : searchKeyword,
      searchType : searchType
    };

    window.sessionStorage.setItem(sessionKey, JSON.stringify(tableInfo));
  }    
}

export const getTableInfoFromSession = (sessionKey) => {
  // get tableInfo from session
  const tableInfo = JSON.parse(window.sessionStorage.getItem(sessionKey));
  if (tableInfo) {
    // clear session table data
    sessionStorage.removeItem(sessionKey);
  }
  return tableInfo;
}

export const doChecked = (cell, enable, eventFunction) => {
  if (cell.getElement) {
    let elFormatterCellCheck = cell.getElement().getElementsByClassName('formatterCell');    
    if (elFormatterCellCheck.length > 0) {
      let appendEl = elFormatterCellCheck[0].cloneNode(true);
      let targetClass, replaceClass, value;
      if (enable) {
        targetClass = 'icon-btn-checkbox-n';
        replaceClass = 'icon-btn-checkbox-p';
        value = 1;
      } else {
        targetClass = 'icon-btn-checkbox-p';
        replaceClass = 'icon-btn-checkbox-n';
        value = 0;
      }
      let elTargetCheck = appendEl.getElementsByClassName(targetClass);
      if (elTargetCheck.length > 0) {
        let elTarget = elTargetCheck[0];
        elTarget.className = replaceClass;
        elTarget.addEventListener('click', () => eventFunction(cell, enable));
        cell.setValue(value);
        let elFormatterCell = elFormatterCellCheck[0];
        elFormatterCell.appendChild(appendEl.firstElementChild);  // because it only has one child, so append first child
      }
    }
  } else {
    console.warn('error in doCheck cell element', cell);
  }
}

export const reloadTable = (table, tableInfo, refFilterSearch) => {
  if (table) {
    // re-set filter
    const keepFilters = tableInfo.filters;
    table.setFilter(keepFilters);

    // re-set headerSort, headerSort is object
    const keepHeaderSort = tableInfo.headerSort;
    table.setSort(keepHeaderSort.field, keepHeaderSort.dir);

    refFilterSearch.setState({
      searchKeyword: tableInfo.searchKeyword,
      searchType: tableInfo.searchType
    });

    // re-set page number
    let pageMax = table.getPageMax();
    let pageNumber = tableInfo.page;
    if (pageNumber > pageMax) {
        pageNumber = pageMax;
    }
    
    setPageNumber(pageNumber);
    table.setPage(pageNumber);

    // update page max number
    updateMaxPageNumber(table);
  }
};

export const groupMenuTitleFormatter = (cell, formatterParams, onRendered) => {    
  let areaTitleBtns = document.createElement("div");
  areaTitleBtns.innerHTML = "<span className='area-group-title-button'><span id='btn-cust-list-settings' className='icon-btn-settings'/></span>";

  const openPopup = (e) => {
    if (formatterParams.tableId) {
      const menu = document.getElementById(`${formatterParams.tableId}ListSettingMenu`);
      if (menu && menu.className.indexOf('show') !== -1) {
        // it's show do nothing to close menu
      } else {
        // it's not show
        setTimeout((e) => {
          const btn = document.getElementById(`${formatterParams.tableId}ListSettingBtn`);
          btn.click();
        }, 10);
      }
    }
  };

  areaTitleBtns.addEventListener('click', openPopup);

  //set header title
  let title = document.createElement("span");    
  title.innerHTML = cell.getValue();

  //add menu to title
  title.appendChild(areaTitleBtns);

  return title;
}

export const commonListFooter = (
  <span>
      <span className='span-show-rows'>Show rows: </span>
      <select id="select-show-row" className='select-show-rows-page' value={50} onChange={() => {}}>
      　<option value="10">10</option>
      　<option value="50">50</option>
      　<option value="100">100</option>
      　<option value="ALL">ALL</option>
      </select>
      <span className='span-go-to'>Go to: </span>
      <input id="go-page-button" className='input-goto-page' type='text' value={1} onChange={() => {}}></input> {/* need onChange={() => {}} to avoid input error */}
      <span className='span-of-max-page'> of<span id='page-max-label' className='max-page-number'/></span>
  </span>
)